import { showSuccessToast } from '@shared/toasts/toasts.state';
import { openAssociationModal } from '@domain/settings/account-association-modal/account-association-modal.state';
import {
    FACEBOOK_INTEGRATION_OPENED,
    FACEBOOK_INTEGRATION_CLOSED,
    FACEBOOK_INTEGRATION_SAVE_TOKEN_SUCCESS,
    FACEBOOK_INTEGRATION_SAVE_TOKEN_FAIL,
} from './facebook-integration.state';

import { setLoading } from '../integrations-list/integrations-list.state';
import { createMiddleware } from '../../../shared/redux';
import { TEXTS } from '../integrations.constants';
import { ID as FACEBOOK_ID } from './facebook-integration.constants';
import { requestRedirectToIntegrationsHome } from '../integration-strategies';

export const facebookMiddleware = createMiddleware({
    [[
        FACEBOOK_INTEGRATION_SAVE_TOKEN_FAIL,
        FACEBOOK_INTEGRATION_CLOSED,
    ]]: () => [setLoading(false)],
    [FACEBOOK_INTEGRATION_SAVE_TOKEN_SUCCESS]: () => [
        setLoading(false),
        showSuccessToast({ message: TEXTS.OPEN_ASSOCIATE_ACCOUNTS_MODAL }),
        requestRedirectToIntegrationsHome(FACEBOOK_ID),
        openAssociationModal(),
    ],
    [FACEBOOK_INTEGRATION_OPENED]: () => setLoading(true),
});
